var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99866 12.4993C11.3792 12.4993 12.4983 11.3801 12.4983 9.99963C12.4983 8.61912 11.3792 7.5 9.99866 7.5C8.61815 7.5 7.49902 8.61912 7.49902 9.99963C7.49902 11.3801 8.61815 12.4993 9.99866 12.4993Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10.7326V9.26614C1.6665 8.3996 2.37473 7.68304 3.24961 7.68304C4.75772 7.68304 5.37429 6.61653 4.61607 5.30839C4.1828 4.5585 4.4411 3.58364 5.19932 3.15037L6.64078 2.32549C7.29901 1.93388 8.14889 2.16718 8.5405 2.82542L8.63215 2.98373C9.38204 4.29187 10.6152 4.29187 11.3734 2.98373L11.4651 2.82542C11.8567 2.16718 12.7066 1.93388 13.3648 2.32549L14.8062 3.15037C15.5645 3.58364 15.8228 4.5585 15.3895 5.30839C14.6313 6.61653 15.2478 7.68304 16.756 7.68304C17.6225 7.68304 18.3391 8.39127 18.3391 9.26614V10.7326C18.3391 11.5991 17.6308 12.3157 16.756 12.3157C15.2478 12.3157 14.6313 13.3822 15.3895 14.6903C15.8228 15.4486 15.5645 16.4151 14.8062 16.8484L13.3648 17.6732C12.7066 18.0649 11.8567 17.8316 11.4651 17.1733L11.3734 17.015C10.6235 15.7069 9.39037 15.7069 8.63215 17.015L8.5405 17.1733C8.14889 17.8316 7.29901 18.0649 6.64078 17.6732L5.19932 16.8484C4.4411 16.4151 4.1828 15.4402 4.61607 14.6903C5.37429 13.3822 4.75772 12.3157 3.24961 12.3157C2.37473 12.3157 1.6665 11.5991 1.6665 10.7326Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting2);
export default __webpack_public_path__ + "static/media/setting-2.68e975aebd44b8275fe78d5af237d2c9.svg";
export { ForwardRef as ReactComponent };